import React from 'react';
import { FAQItem } from './FAQItem';
import { Highlight } from './ui/HeroHighlight';
import { BookCallButton } from './ui/BookCallButton';
export const FAQSection = () => {
  const scrollToCalendly = () => {
    const element = document.getElementById('calendly');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const faqs = [{
    question: 'What will I be doing day-to-day?',
    answer: "You'll start conversations with 2–4 homeowners each day, present energy solutions, and guide them through upgrades — with live coaching to help you improve quickly."
  }, {
    question: 'How much can I earn?',
    answer: 'Most new reps earn $55K–$80K+ in year one. Experienced closers make $10K–$20K+ per month, and leaders earn $200K–$500K+ annually.'
  }, {
    question: 'Is this commission-only?',
    answer: 'Yes — this is a performance-based role with no cap on earnings. The more sales you generate, the more you make.'
  }, {
    question: 'What training do I get?',
    answer: 'We provide paid, hands-on training, ride-alongs, and coaching from six-figure earners with 100+ years of combined experience.'
  }, {
    question: 'Who thrives here?',
    answer: 'Coachable, competitive, growth-minded people who stay positive, work hard, and want to build a career.'
  }];
  return <div className="w-full py-16 sm:py-24" data-id="element-33">
      <div className="max-w-4xl mx-auto px-4" data-id="element-34">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-8 sm:mb-12 text-white text-center" data-id="element-35">
          Frequently Asked <Highlight data-id="element-36">Questions</Highlight>
        </h2>
        <div className="rounded-xl mb-12" data-id="element-37">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-38" />)}
        </div>
        <div className="flex justify-center" data-id="element-39">
          <BookCallButton onClick={scrollToCalendly} data-id="element-40" />
        </div>
      </div>
    </div>;
};